"use client";

import { TKey } from "@/app/translations/TKey";
import { PlanSettings } from "@/app/types/billing/PlanSettings";
import { PageProps } from "@/app/types/common/PageProps";
import { CreditOffer } from "@/app/vars/Credits";
import CallToCTA from "../components/CallToCTA/CallToCTA";
import ConceptFlow from "../components/ConceptFlow/ConceptFlow";
import FAQ from "../components/FAQ/FAQ";
import { MEIDLY_FAQ } from "../components/FAQ/FAQ.logic";
import ForWho from "../components/ForWho/ForWho";
import Hero from "../components/Hero/Hero";
import HowItWorks from "../components/HowItWorks/HowItWorks";
import { HOW_IT_WORKS_SECTION_ID } from "../components/HowItWorks/HowItWorks.logic";
import Layout from "../components/Layout/Layout";
import Pricing from "../components/Pricing/Pricing";
import SectionArrow from "../components/SectionArrow/SectionArrow";
import styles from "../Home.module.css";

type Props = PageProps & {
  plan: PlanSettings;
};

export default function Meidly(props: Props) {
  return (
    <Layout>
      <div className={styles.content}>
        <Hero
          params={props.params}
          freeCredits={CreditOffer.SIGNUP_CREDITS}
          keys={{
            supTitle: TKey.HOME_MEIDLY_HERO_SUP_TITLE,
            secondaryCta: TKey.HOME_MEIDLY_HERO_SECONDARY_CTA,
            pricing: TKey.HOME_MEIDLY_HERO_PRICING,
            title: TKey.HOME_MEIDLY_HERO_TITLE,
            text: TKey.HOME_MEIDLY_HERO_TEXT,
          }}
        />
      </div>

      <SectionArrow />

      <div className={styles.content}>
        <ConceptFlow />
      </div>

      <div className={styles.scrollTarget} id={HOW_IT_WORKS_SECTION_ID}>
        <HowItWorks />
      </div>

      <div className={`${styles.scrollTarget} ${styles.joined}`} id="who">
        <ForWho />
      </div>

      <div className={`${styles.content} ${styles.scrollTarget} ${styles.joined}`} id="tarifs">
        <Pricing params={props.params} plan={props.plan} />
      </div>

      <div className={`${styles.content} ${styles.scrollTarget}`} id="faq">
        <FAQ params={props.params} keys={MEIDLY_FAQ} />
      </div>

      <div className={styles.content}>
        <CallToCTA
          params={props.params}
          keys={{
            title: TKey.HOME_MEIDLY_CTA_TITLE,
            text: TKey.HOME_MEIDLY_CTA_TEXT,
          }}
        />
      </div>
    </Layout>
  );
}
